import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_nuxtmailrucounterplugin6932832a_5087f450 from 'nuxt_plugin_nuxtmailrucounterplugin6932832a_5087f450' // Source: ./nuxt-mailru-counter.plugin.6932832a.js (mode: 'client')
import nuxt_plugin_nuxtvkretargetingplugin46d93647_bb5ea97c from 'nuxt_plugin_nuxtvkretargetingplugin46d93647_bb5ea97c' // Source: ./nuxt-vk-retargeting.plugin.46d93647.js (mode: 'client')
import nuxt_plugin_yandexmetrikaplugin27716ce3_91209844 from 'nuxt_plugin_yandexmetrikaplugin27716ce3_91209844' // Source: ./yandex-metrika.plugin.27716ce3.js (mode: 'client')
import nuxt_plugin_markdownit_db791810 from 'nuxt_plugin_markdownit_db791810' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_42881812 from 'nuxt_plugin_moment_42881812' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_fmt_caeabbce from 'nuxt_plugin_fmt_caeabbce' // Source: ../plugins/fmt (mode: 'all')
import nuxt_plugin_toast_46bc8166 from 'nuxt_plugin_toast_46bc8166' // Source: ../plugins/toast.client (mode: 'client')
import nuxt_plugin_polyfills_f131d02e from 'nuxt_plugin_polyfills_f131d02e' // Source: ../plugins/polyfills.client (mode: 'client')
import nuxt_plugin_vuelazyhydrate_14378655 from 'nuxt_plugin_vuelazyhydrate_14378655' // Source: ../plugins/vue-lazy-hydrate (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vueawesomeswiper_0f4ed586 from 'nuxt_plugin_vueawesomeswiper_0f4ed586' // Source: ../plugins/vue-awesome-swiper (mode: 'all')
import nuxt_plugin_vuecontentplaceholders_5f72ae0f from 'nuxt_plugin_vuecontentplaceholders_5f72ae0f' // Source: ../plugins/vue-content-placeholders (mode: 'all')
import nuxt_plugin_vueobservevisibility_31cf76fe from 'nuxt_plugin_vueobservevisibility_31cf76fe' // Source: ../plugins/vue-observe-visibility (mode: 'all')
import nuxt_plugin_vmask_42ab70d7 from 'nuxt_plugin_vmask_42ab70d7' // Source: ../plugins/v-mask (mode: 'all')
import nuxt_plugin_vueperfectscrollbar_087aa0ae from 'nuxt_plugin_vueperfectscrollbar_087aa0ae' // Source: ../plugins/vue-perfect-scrollbar.client (mode: 'client')
import nuxt_plugin_vuechatscroll_f37e9eb2 from 'nuxt_plugin_vuechatscroll_f37e9eb2' // Source: ../plugins/vue-chat-scroll (mode: 'all')
import nuxt_plugin_topmailrucounter_1371129d from 'nuxt_plugin_topmailrucounter_1371129d' // Source: ../plugins/top-mail-ru-counter.client (mode: 'client')
import nuxt_plugin_auth_7543862a from 'nuxt_plugin_auth_7543862a' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_authi18n_164a78a2 from 'nuxt_plugin_authi18n_164a78a2' // Source: ../plugins/auth-i18n (mode: 'all')
import nuxt_plugin_notifications_3edb2b74 from 'nuxt_plugin_notifications_3edb2b74' // Source: ../plugins/notifications (mode: 'all')
import nuxt_plugin_init_600fa816 from 'nuxt_plugin_init_600fa816' // Source: ../plugins/init.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ficon.png"},{"rel":"preload","as":"font","crossorigin":"crossorigin","type":"font\u002Fttf","href":"\u002Ffonts\u002FUnbounded\u002FUnboundedVariable.ttf"},{"href":"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js","rel":"preload","as":"script"}],"meta":[{"property":"format-detection","content":"telephone=no"},{"property":"twitter:url","content":""},{"name":"yandex-verification","content":"978bc0405f052c8f"},{"name":"google-site-verification","content":"8OwTCG47uuwQ9Ho4ZbhKgWXh3BJ-O87XDVIKi7mIqf4"},{"hid":"og:locale","property":"og:locale","content":"ru"},{"hid":"twitter:title","property":"twitter:title","content":"Открытые инновации 2024"},{"hid":"twitter:description","property":"twitter:description","content":"Открытые инновации - крупнейшее в России и одно из узнаваемых в мире конгрессно-выставочных мероприятий, проходящее ежегодно с 2012 года под эгидой Правительства Российской Федерации"},{"hid":"facebook-domain-verification","name":"facebook-domain-verification","content":"w6y874a3w62kb22c18sf4ik5ocspqx"},{"hid":"og:image","property":"og:image","content":"\u002Fog-img.jpg"},{"hid":"twitter:image","property":"twitter:image","content":"\u002Fog-img.jpg"},{"hid":"vk:image","property":"vk:image","content":"\u002Fog-img.jpg"},{"hid":"og:image:width","property":"og:image:width","content":"540"},{"hid":"og:image:height","property":"og:image:height","content":"320"}],"style":[],"script":[{"src":"https:\u002F\u002Fvk.com\u002Fjs\u002Fapi\u002Fopenapi.js?169","async":true},{"src":"https:\u002F\u002Ftop-fwz1.mail.ru\u002Fjs\u002Fcode.js","async":true}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtmailrucounterplugin6932832a_5087f450 === 'function') {
    await nuxt_plugin_nuxtmailrucounterplugin6932832a_5087f450(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvkretargetingplugin46d93647_bb5ea97c === 'function') {
    await nuxt_plugin_nuxtvkretargetingplugin46d93647_bb5ea97c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexmetrikaplugin27716ce3_91209844 === 'function') {
    await nuxt_plugin_yandexmetrikaplugin27716ce3_91209844(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_db791810 === 'function') {
    await nuxt_plugin_markdownit_db791810(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
    await nuxt_plugin_pluginutils_ea6a7e96(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_42881812 === 'function') {
    await nuxt_plugin_moment_42881812(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_fmt_caeabbce === 'function') {
    await nuxt_plugin_fmt_caeabbce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_46bc8166 === 'function') {
    await nuxt_plugin_toast_46bc8166(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_f131d02e === 'function') {
    await nuxt_plugin_polyfills_f131d02e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyhydrate_14378655 === 'function') {
    await nuxt_plugin_vuelazyhydrate_14378655(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_vueawesomeswiper_0f4ed586 === 'function') {
    await nuxt_plugin_vueawesomeswiper_0f4ed586(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecontentplaceholders_5f72ae0f === 'function') {
    await nuxt_plugin_vuecontentplaceholders_5f72ae0f(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_31cf76fe === 'function') {
    await nuxt_plugin_vueobservevisibility_31cf76fe(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_42ab70d7 === 'function') {
    await nuxt_plugin_vmask_42ab70d7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueperfectscrollbar_087aa0ae === 'function') {
    await nuxt_plugin_vueperfectscrollbar_087aa0ae(app.context, inject)
  }

  if (typeof nuxt_plugin_vuechatscroll_f37e9eb2 === 'function') {
    await nuxt_plugin_vuechatscroll_f37e9eb2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_topmailrucounter_1371129d === 'function') {
    await nuxt_plugin_topmailrucounter_1371129d(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7543862a === 'function') {
    await nuxt_plugin_auth_7543862a(app.context, inject)
  }

  if (typeof nuxt_plugin_authi18n_164a78a2 === 'function') {
    await nuxt_plugin_authi18n_164a78a2(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_3edb2b74 === 'function') {
    await nuxt_plugin_notifications_3edb2b74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_init_600fa816 === 'function') {
    await nuxt_plugin_init_600fa816(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
